<div class='wrapperPopupCongrats'>
  <img src='assets/congrats.svg' alt=''>
  <div class='titlePopupCongrats'>Congrats!</div>
  <div class='subTitlePopupCongrats'>You've earned 20 game credits to help get you started.</div>
  <btnWrap type='col'>
    <btn text='Got it!' bcg='blueDark' (click)='close()'></btn>
    <btn text='Buy More Credits' bcg='white' (click)='null'></btn>
  </btnWrap>
</div>